import { Box, Stack } from "@mui/material";
import { PaperMaterialsPermission } from "commons/enum/permission";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { useCallback } from "react";
import { PaperMaterialFilterKey } from "share-components/group-selection/paper-material-group-selection/use-paper-material-group-selection";
import { AddButton } from "share-components/mui-wrap/button/action-button";
import { SearchButton } from "share-components/mui-wrap/button/search-button";
import { PageContentContainer } from "share-components/templates/page/page-content-container";
import { PageFilterContainer } from "share-components/templates/page/page-filter-container";
import { AddPaperMaterial } from "../add-material/add-material";
import { PaperMaterialGroupSelectionConnected } from "../share";
import { UpdatePaperMaterial } from "../update-material/update-paper-material";
import { PaperMaterialTable } from "./paper-material-table";

export const PaperMaterialList = observer(() => {
  const {
    paperMaterialStore: {
      pagination,
      getPapersMaterial,
      openNew,
      openEdit,
      setProp,
      queryParams: { code, gsm, setProp: setQueryParamProps, type },
    },
  } = useStores();
  const onSearch = useCallback(async () => {
    pagination.setProp("pageIndex", 0);
    await getPapersMaterial();
  }, [getPapersMaterial, pagination]);

  const setGroupSelectionProp = useCallback(
    (prop: PaperMaterialFilterKey, value: string) => {
      if (prop === "code" || prop === "type" || prop === "gsm") {
        setQueryParamProps(prop, value);
      }
    },
    [setQueryParamProps],
  );

  return (
    <>
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <PageFilterContainer>
          <PaperMaterialGroupSelectionConnected
            codeSelected={code}
            specificationSizeSelected={""}
            brandSelected={""}
            rollNumberSelected={""}
            typeSelected={type}
            gsmSelected={gsm}
            visibleFields={["code", "type", "gsm"]}
            setSelectionProp={setGroupSelectionProp}
          />

          <SearchButton asyncAction={onSearch}></SearchButton>
        </PageFilterContainer>
        <Box>
          <AddButton
            accessPermission={[PaperMaterialsPermission.Create]}
            onClick={() => {
              setProp("openNew", true);
            }}
          >
            Thêm vật tư giấy
          </AddButton>
        </Box>
      </Stack>
      <PageContentContainer sx={{ marginTop: "10px" }}>
        <PaperMaterialTable></PaperMaterialTable>
      </PageContentContainer>

      <>
        {openNew && <AddPaperMaterial></AddPaperMaterial>}
        {openEdit && <UpdatePaperMaterial></UpdatePaperMaterial>}
      </>
    </>
  );
});
